const setUpPaymentPlan = 'Set up a payment plan';

export default {
  intro: {
    screenTitle: 'Big purchase?\nSplit it up.',
    subtitle:
      'Plan ahead and split your next debit card purchase into 4 payments for a 6% fee.',
    disclosure:
      'Payments vary by purchase amount. For a $500 purchase, you’ll make 4 payments of $132.50 every 15 days. This includes a $30 fee. 0% down. 57.72% APR.',
    setUpPaymentPlan,
    howItWorks: 'How it works',
  },
  howItWorks: {
    navigationTitle: 'How Pay Later works',
    setUpPaymentPlan,
    purchaseRestrictions: {
      body: 'You can’t use Pay Later for some types of purchases.',
      link: 'See Pay Later purchase restrictions.',
    },
    steps: {
      planPurchase: {
        title: 'Plan your purchase',
        body: 'Tell us how much you want to spend to see your estimated payments.',
      },
      payWithDebitCard: {
        title: 'Pay with your debit card',
        body: 'Use your debit card to pay for your purchase. Pay Later splits your purchase into 4 payments, so you pay $0 at checkout.',
      },
      getFinalPlan: {
        title: 'Get your final plan',
        body: 'See your exact payment amounts and schedule after your purchase.\n\nBefore you buy, you’ll see an estimate.',
      },
    },
  },
  purchaseRestrictions: {
    title: 'Pay Later purchase restrictions',
    body: 'You can’t use Pay Later for some types of purchases, including:',
    restrictions: {
      diningTravel: 'Paying for restaurants, hotels, or car rentals',
      ridesDelivery: 'Paying for rides or delivery services',
      gasPumps: 'Paying at gas pumps',
      gambling: 'Gambling or buying lottery tickets',
      cash: 'Getting cash or cash advances',
      restrictedProducts: 'Buying alcohol or other restricted products',
      cryptocurrency: 'Buying cryptocurrency',
      prepaidGiftCards: 'Buying prepaid or gift cards',
      taxesBailPawn: 'Paying taxes, bail, or pawn shops',
      jewelryPreciousMetals: 'Buying jewelry or precious metals',
    },
    done: 'Done',
  },
};
